import { Component, OnInit, ViewChild, OnChanges, SimpleChanges, EventEmitter, Output } from '@angular/core';
import { Validators, FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { Message, MenuItem, SelectItem, TreeNode } from 'primeng/components/common/api';
import { GenericService } from '../../../_services/generic-service';
import { Utils } from '../../../utils';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Observable } from 'rxjs';


@Component({
    selector: "generic-component",
    templateUrl: './generic.component.html',
    //    encapsulation: ViewEncapsulation.None,

    providers: [GenericService],


})

export class GenericComponent implements OnInit, OnChanges {
    @Output() onchange = new EventEmitter<any>();
    @Output() onLoadRow = new EventEmitter<any>();
    @Output() onSaveItem = new EventEmitter<any>();
    @Output() onAddClick = new EventEmitter<any>();

    _action: string;
    blockedUI: boolean = false;
    arrTable: any[];
    msgs: Message[] = [];
    displayDialogElimina: boolean = false;
    loading: boolean = false;
    displayDialogAddEdit: boolean = false;
    genericform: FormGroup;
    itCalendar: any;



    constructor(private service: GenericService) {
        this.itCalendar = {
            firstDayOfWeek: 1,
            dayNames: ["Domenica", "Lunedi", "Martedi", "Mercoledi", "Giovedi", "Venderdi", "Sabato"],
            dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
            dayNamesMin: ["Do", "Lu", "Ma", "Me", "Gi", "Ve", "Sa"],
            monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembere"],
            monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dec"],
            today: 'Oggi',
            clear: 'Pulisci'
        };

        Utils.log("constructor")

    }
    ngOnChanges(changes: SimpleChanges): void {
        // throw new Error("Method not implemented.");
        Utils.log("ngOnchange", changes);
    }

    ngOnInit() {
        Utils.log("ngOnInit", this.genericform);
        this.arrTable = [];
    }


    loadTable(name: string) {
        Utils.log("LoadTable: ");
        Utils.log(this.service);
        this.loading = true;
        this.service.getAll().then(
            res => {

                if (res.response == 0) {
                    let arrTable = res.data[name]
                    Utils.log("arrTable", arrTable)
                    this.arrTable = arrTable;
                    this.loading = false
                } else {
                    this.msgs = [];
                    this.msgs.push({ severity: 'error', summary: 'Errore', detail: this.getMessageError(res) });
                }
            }
        );
    }


    showDialogAdd() {
        this.onAddClick.emit(null);
        this.cleanForm();
        this.displayDialogAddEdit = true;

    }

    cleanForm() {
        Utils.log("cleanform");
        this.displayDialogAddEdit = false;
        this.genericform.reset();


    }

    idToDelete = 0;
    delete(id, who) {
        if (who == 0) {

            this.displayDialogElimina = true;
            this.idToDelete = id;
            return;
        }



        id = this.idToDelete;


        let arrTable = [...this.arrTable];
        this.service.delete(id).then(
            res => {

                if (res.response == 0) {

                    arrTable = Utils.remove(arrTable, "id", id);
                    this.arrTable = arrTable;
                    this.onchange.emit(this.arrTable);
                    this.showInfoMessage("Eliminato correttamente", null);
                } else {

                    this.showMessageError(res)

                }

                this.displayDialogElimina = false;
            }
        );
        this.idToDelete = 0;

    }


    edit(object: any, name: string) {

        // Utils.log("selected1 ", this.selectedDomande);
        this.cleanForm();
        this.loading = true;
        this.service.getById(object.id).then(
            res => {

                if (res.response == 0) {
                    let u = res.data[name];
                    this.onLoadRow.emit(u)
                    this.genericform.patchValue(u);
                    this.loading = false
                    this.displayDialogAddEdit = true;
                } else {
                    this.showMessageError(res)
                }
            }
        );

    }

    copy(object: any, name: string) {

        // Utils.log("selected1 ", this.selectedDomande);
        this.cleanForm();
        this.loading = true;
        this.service.getById(object.id).then(
            res => {

                if (res.response == 0) {
                    let u = res.data[name];
                    u.id = null;
                    this.genericform.patchValue(u);
                    this.loading = false;
                    this.displayDialogAddEdit = true;
                    this.onLoadRow.emit(u);

                } else {
                    this.showMessageError(res)
                }
            }
        );

    }

    update(object: any, name: string) {
        this.blockedUI = true;
        Utils.log(this.arrTable);
        let arrTable = null;
        if (this.arrTable != null && this.arrTable.length > 0)
            arrTable = [...this.arrTable];


        this.service.update(object).then(
            res => {
                this.blockedUI = false;
                if (res.response == 0) {


                    if (name != undefined && name != null && name != "" && arrTable != null) {
                        let u = res.data[name];
                        arrTable = Utils.remove(arrTable, "id", object.id);
                        this.updateTable(u, arrTable);
                    } else {
                        this.showMessageSuccess();

                    }


                } else {
                    this.showMessageError(res)
                }
            }
        );
    }



    showMessage(severity: string, summary: string, detail: string) {


        this.msgs = [];
        this.msgs.push({ severity: severity, summary: summary, detail: detail });

        this.setHideTimeout();
    }

    setHideTimeout() { setTimeout(() => { this.msgs = []; }, 4000); }

    showInfoMessage(summary: string, detail: string) {
        this.showMessage('info', summary, detail);
    }


    showMessageSuccess() {
        this.showInfoMessage('Conferma', "Operazione eseguita con successo");
    }

    showMessageError(res) {
        this.showMessage('error', 'Errore', this.getMessageError(res));
    }


    sendToServerObject(name: string, object: any) {


        //Utils.log(object);
        if (object.id > 0) {
            this.update(object, name);
        } else {
            this.insert(object, name);
        }
    }

    sendToServer(name: string) {
        Utils.log(name);
        Utils.log(this.genericform.value);
        this.onSaveItem.emit(this.genericform);
        this.sendToServerObject(name, this.genericform.value);
    }


    insertPromise(object: any) {

        this.blockedUI = true;
        return new Promise((resolve, reject) => {


            this.service.create(object).then(
                res => {
                    this.blockedUI = false;
                    if (res.response == 0) {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                }
            );
        });
    }

    updatePromise(object: any) {

        this.blockedUI = true;
        return new Promise((resolve, reject) => {
            this.service.update(object).then(
                res => {
                    this.blockedUI = false;
                    if (res.response == 0) {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                }
            );
        });
    }

    genericCallService(method: string, object: any) {
        this.blockedUI = true;
        return new Promise((resolve, reject) => {
            this.service[method](object).then(
                res => {
                    this.blockedUI = false;
                    if (res.response == 0) {
                        resolve(res.data);
                    } else {
                        reject(res);
                    }
                }
            );
        });
    }

    genericCallServiceBack(method: string, object: any, location: Location) {
        this.genericCallService(method, object).then(data => {
            location.back();
        }).catch(e => {
            this.showMessageError(e)
        });
    }

    getMessageError(e) {
        const OK = 0;
        const ERROR_REQUIRED_FIELDS = 1;
        const ERROR_INSERT_DB = 2;
        const ERROR_ID_NOT_VALID = 3;
        const ERROR_ACTION_PARAM_NOT_VALID = 4;
        const ERROR_DELETE_DB = 5;
        const ERROR_UPDATE_DB = 6;
        const ERROR_DUPLICATE_ENTRY = 7;
        const ERROR_SESSION_NOT_VALID = 8;
        const ERROR_PASSORD_DONT_MACTH = 9;
        const ERROR_EMAIL_NOT_SENT = 10;
        const ERROR_PURCHASE = 11;
        const ERROR_SIZE_LIMIT_REQUEST = 12;
        const ERROR_DELETE_DB_REFERENCE = 13;
        const ERROR_INVALID_USERNAME_PASSWORD = 14;
        const ERROR_INVALID_SESSION = 15;
        const ERROR_NOT_AUTHORIZED = 16;
        const ERROR_USER_DISABLED = 17;
        const ERROR_PAYPAL = 18;
        const ERROR_AUDIT_NOT_VALID = 19;
        let message = e.errors;

        /*
        if (e.response == ERROR_USER_DISABLED) {
            message = "Utente Disabilitato";
        } else if (e.response == ERROR_ACTION_PARAM_NOT_VALID) {
            message = "Inserire tutti campi previsti";
        } else if (e.response == ERROR_DELETE_DB_REFERENCE) {
            message = "Impossibile eliminare perché referenziato";
        } else if (e.response == ERROR_PASSORD_DONT_MACTH) {
            message = "Le password non coincidono";
        } else if (e.response == ERROR_DUPLICATE_ENTRY) {
            message = "Elemento già presente";
        } else if (e.response == ERROR_PAYPAL) {
            message = "Errore nel pagamento. Contattare il supporto";
        }
        else if (e.response == ERROR_AUDIT_NOT_VALID) {
            message = "Errore nella compilazione dell'Audit";
        }*/

        return message;

    }


    insertBack(object: any, location: Location) {
        this.insertPromise(object).then(data => {
            this.goBack(location);
        }).catch(e => {
            this.showMessageError(e)
        });
    }


    sendToServerBack(object: any, location: Location) {

        if (this._action == 'create') {
            this.insertBack(object, location);
        } else
            this.updateBack(object, location);

    }

    goBack(location: Location): void {
        location.back();
    }

    updateBack(object: any, location: Location) {
        this.updatePromise(object).then(data => {
            this.goBack(location);
        }).catch(e => {
            this.showMessageError(e)
        });
    }

    insert(object: any, name: string) {
        this.blockedUI = true;
        Utils.log(this.arrTable);
        Utils.log(object);
        let arrTable = [];
        if (name != undefined && name != null && name != "") {
            arrTable = [...this.arrTable];
        }
        //Utils.log("pre insert", arrTable);
        this.service.create(object).then(
            res => {
                this.blockedUI = false;
                if (res.response == 0) {
                    if (name != undefined && name != null && name != "") {
                        let u = res.data[name];
                        this.updateTable(u, arrTable);
                    } else {
                        this.showMessageSuccess();
                    }

                } else {
                    this.showMessageError(res)
                }
            }
        );
    }

    updateTable(object: any, arrTable) {
        arrTable.push(object);
        this.arrTable = arrTable;

        this.onchange.emit(this.arrTable);
        Utils.log("after insert", arrTable, this.arrTable);
        this.displayDialogAddEdit = false;
        this.showMessageSuccess();
        this.cleanForm();
    }


    writeBooleanText(value) {
        // Utils.log("value", value);
        if (value == undefined || value == null || value == false || value == 0) {
            return "NO";
        } else {
            return "SI";
        }

    }

    reloadPage() {
        window.location.reload();
    }

}


// WEBPACK FOOTER //
// ./src/app/theme/layouts/custom-component/generic-component.ts